import { ScriptService } from './../../../services/cms/script.service';
//Angular
import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ViewContainerRef, Compiler, Input, Inject, Renderer } from "@angular/core";

//Services
import { ClientAreaService } from "./../../../services/settings/client-area.service";
import { LanguageService } from "./../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../services/core/component-helper.service";
import { AuthService } from "./../../../services/core/auth.service";
import { TemplateService } from "./../../../services/settings/template.service";
import { Router } from "@angular/router";
import { RoutesService } from "./../../../services/core/routes.service";
import { TranslateService } from "@ngx-translate/core";
import { SeoService } from "../../../services/core/seo.service";
import { BreadcrumbsService } from './../../../services/cms/breadcrumbs.service';
import { CmsComponentService } from "./../../../services/cms/cms-component.service";
import { ShoppingCartService } from "./../../../services/inventory/shopping-cart.service";
import { BootboxService } from '../../../services/core/bootbox.service';

//Models
import { ClientAreaOrderDetails } from "./../../../models/settings/client-area";
import { CookieService } from "../../../services/core/cookie/cookie.service";
import { ApiService } from "../../../services/core/api.service";
import { MessagesService } from "../../../services/core/messages.service";
import { Mappings } from "../../../shared/mapping";
import { Breadcrumbs } from './../../../models/cms/breadcrumbs';

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from "@angular/platform-browser";
import { CurrencyService } from '../../../services/cms/currency.service';
import { forEach } from '@angular/router/src/utils/collection';
import { Observable } from 'rxjs';
import { RegistrationConfirmationComponent } from '../../settings/user/sys/registration-confirmation.component';
import { setFlagsFromString } from 'v8';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  template: ""
})
export class ClientAreaOrderListComponent implements OnInit {
  constructor
    (
      private _compiler: Compiler,
      private componentHelper: ComponentHelperService,
      private _elementRef: ViewContainerRef,
      private templateService: TemplateService,
      private authService: AuthService,
      private router: Router,
      private clientAreaService: ClientAreaService,
      private cmsComponentService: CmsComponentService,
      @Inject('isBrowser') private isBrowser: boolean,
      private seo: SeoService,
      private renderer: Renderer,
      @Inject(DOCUMENT) private document: any
    ) { }

  subManager = new Subscription();

  ngOnInit() {
    if (!this.authService.GetData().isAuthenticated || this.authService.GetData().isAuthenticated === undefined) {
      this.router.navigate([""]);
    }
    else {
      let ClientAreaOrderListTemplate: any;
      let userId = this.authService.GetUserId();
      let showAll: string = "-1"
      let registrationConfirmation: any;
      let header: any;
      let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
        header = result;
        let SideMenuData = this.cmsComponentService.getSideMenuData().subscribe(result1 => {
          if (result1.Categories) {
            header.Categories = result1.Categories;

          }
        });
        this.subManager.add(SideMenuData);
      });
      this.subManager.add(headDataSub);
      let orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, showAll, showAll, showAll, showAll).subscribe(result => {

        ClientAreaOrderListTemplate = result;

        // Creating subcomponent whith the selected template to inject
        let subComponent = this.createSubComponent(ClientAreaOrderListTemplate, header);

        //injecting created component (OK)
        this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

      })

      this.subManager.add(orderListSub);
    }
  }

  ngOnDestroy() {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subManager.unsubscribe();
  }

  private createSubComponent(ClientAreaOrderListTemplate: any, header: any) {

    @Component({
      template: ClientAreaOrderListTemplate.TemplateHtml
    })

    class ChildComponent implements OnInit {
      constructor
        (
          @Inject('CookieService') private cookie: CookieService,
          private clientAreaService: ClientAreaService,
          private router: Router,
          private authService: AuthService,
          private routesService: RoutesService,
          private apiService: ApiService,
          private messagesService: MessagesService,
          private mappings: Mappings,
          private cartService: ShoppingCartService,
          public currency: CurrencyService,
          private languageService: LanguageService,
          private translateService: TranslateService,
          private bootboxService: BootboxService,
          @Inject('isBrowser') private isBrowser: boolean,
          private seoService: SeoService,
          private breadcrumbsService: BreadcrumbsService,
          private scriptService: ScriptService
        ) { }

      private pageIsInit: boolean = false;

      public rows: Array<any> = [];

      public rowsRiorder: Array<any> = [];

      public columns: Array<any> = [];

      //translating of header columns titles
      translateTableColumnTitle(columnTitle) {
        let translation = this.translateService.get(columnTitle)["value"];
        return translation;
      }

      @Input() clientModel: Array<ClientAreaOrderDetails>;

      private status: string = "0";
      private orderNumber: string = "";

      private lang: string = this.languageService.getLongLang();
      private shortLang: string = this.languageService.getShortLang();

      private modalTitle: string = "MESSAGES:";
      private modalBody: string = "";
      private numberOfMessages: number = 0;
      private bodyMod = [];

      private isSettedFilter: boolean = false;
      private from: any;
      private to: any;
      private load: boolean = true;
      private loadReorder: boolean = true;
      //checking if invoices and multiple shipment modules are active
      private multipleShipmentActive: boolean = ClientAreaOrderListTemplate.isActiveMultipleShipment;

      private breadcrumbs: Breadcrumbs[] = ClientAreaOrderListTemplate.BreadcrumbsInfo;

      //Routes for menu-tabs
      private areaClientiHome: string[] = this.routesService.getRoutePath('AREA CLIENTI - STATISTICHE');
      private areaClientiOrdini: string[] = this.routesService.getRoutePath('AREA CLIENTI - LISTA ORDINI');
      private areaChangeProfile: string[] = this.routesService.getRoutePath('AREA CLIENTI - DATI UTENTE - CAMBIO DATI PERSONALI');
      private areaClientiInvoices: string[] = this.routesService.getRoutePath('AREA CLIENTI - INVOICES');
      private areaClientiCatalogoRiservato: string[] = this.routesService.getRoutePath('RESERVED - CATALOG');
      private isActiveInvoicesModule: boolean = ClientAreaOrderListTemplate.isActiveInvoicesModule;
      private isCatalogPrivateActive: boolean = ClientAreaOrderListTemplate.isCatalogPrivateActive;
      private isRiordinaActive: boolean = ClientAreaOrderListTemplate.isRiordinaActive;
      currentLang;
      italianLang = {
        "sProcessing": "Attendere...",
        "sLengthMenu": "Visualizza _MENU_ record per pagina",
        "sZeroRecords": "Niente trovato",
        "sInfo": "Mostra _START_ a _END_ di _TOTAL_ record",
        "sInfoEmpty": "Non ci sono record",
        "sInfoFiltered": "(filtrato da _MAX_ record totali)",
        "sInfoPostFix": "",
        "sUrl": "",
        "oPaginate": {
          "sPrevious": "«",
          "sNext": "»"
        }
      }

      englishLang = {
        "oPaginate": {
          "sPrevious": "«",
          "sNext": "»"
        }
      }

      subManager = new Subscription();

      footerData: any = ClientAreaOrderListTemplate.FooterData;
      headerData: any = header;

      ngOnInit() {
        setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

        if (this.multipleShipmentActive == false && this.isRiordinaActive == false) {
          this.columns = [
            { title: '' },
            { title: this.translateTableColumnTitle("Jobname") },
            { title: this.translateTableColumnTitle("OrderNumber") },
            { title: this.translateTableColumnTitle("OrderDate") },
            { title: this.translateTableColumnTitle("PriceTotalCell") },
            { title: this.translateTableColumnTitle("Status") },
            { title: this.translateTableColumnTitle("FileVerification") },
            { title: this.translateTableColumnTitle("Payment") },
            { title: this.translateTableColumnTitle("Shipment") },
            { title: '' },
            { title: '' },
          ];
        }

        else if (this.isRiordinaActive == false) {
          this.columns = [
            { title: '' },
            { title: this.translateTableColumnTitle("Jobname") },
            { title: this.translateTableColumnTitle("OrderNumber") },
            { title: this.translateTableColumnTitle("OrderDate") },
            { title: this.translateTableColumnTitle("PriceTotalCell") },
            { title: this.translateTableColumnTitle("Status") },
            { title: this.translateTableColumnTitle("FileVerification") },
            { title: this.translateTableColumnTitle("Payment") },
            { title: '' },
            { title: '' },
          ];
        }
        else {
          this.columns = [
            { title: '' },
            { title: this.translateTableColumnTitle("Jobname") },
            { title: this.translateTableColumnTitle("OrderNumber") },
            { title: this.translateTableColumnTitle("OrderDate") },
            { title: this.translateTableColumnTitle("PriceCell") },
            { title: this.translateTableColumnTitle("Status") },
            { title: this.translateTableColumnTitle("FileVerification") },
            { title: this.translateTableColumnTitle("Payment") },
            { title: '' },
            { title: '' },
            { title: '' },
          ];
        }

        //getting of Datatable data
        this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;
        this.load = false;
        this.loadReorder = false;

      }
      ngAfterViewChecked() {

        if (!this.isBrowser || this.pageIsInit) {
          return;
        }

        //hiding of loading panel after we get all data we need
        this.routesService.hidePageLoader();

        if (this.shortLang == 'en') {
          this.currentLang = this.englishLang;
        }
        else {
          this.currentLang = this.italianLang;
        }

        //initialization of datatable
        $('#datatable').DataTable({
          searching: false,
          ordering: false,
          sDom: 'Rlfrtlip',
          oLanguage: this.currentLang
        });

        //hiding of first 'per page' section, because we added it on the bottom of the table
        $('.dataTables_length').not(':eq(1)').hide();


        //initialization of datetime picker from and to
        $('#fromDate').datetimepicker(
          {
            locale: this.shortLang,
            format: 'DD/MM/YYYY'
          }
        );

        $('#toDate').datetimepicker(
          {
            locale: this.shortLang,
            useCurrent: false, //Important! See issue #1075
            format: 'DD/MM/YYYY'
          }
        );

        $("#fromDate").on("dp.change", function (e) {
          $('#toDate').data("DateTimePicker").minDate(e.date);
        }
        );

        $("#toDate").on("dp.change", function (e) {
          $('#fromDate').data("DateTimePicker").maxDate(e.date);
        }
        );


        this.pageIsInit = true;
      }

      onClick(indexRow: any, columnName?: string) {
        let indexColumn;
        let orderId = this.rows[indexRow].OrderId;

        if (columnName == undefined) {
          let orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE')[0];

          orderDetailsPage = orderDetailsPage.replace(':id', orderId.toString());

          this.router.navigate([orderDetailsPage]);
        }
        else if (columnName == 'Upload') {
          let loginRoute = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];
          loginRoute = loginRoute.replace(":id", orderId);
          loginRoute = loginRoute.replace(":pagefrom", "section_upload");

          this.router.navigate([loginRoute]);
        }
        else if (columnName == 'OrderNotesCell') {
          let order = this.rows[indexRow];

          //Reading only the messsages for the selected order
          this.bodyMod = order.OrderNoteList;
          this.numberOfMessages = this.bodyMod.length;

          //The modal is showed only if there are messages
          if (this.bodyMod.length > 0) {
            let userId = this.authService.GetUserId();
            let params =
            {
              CustomerId: userId.toString(),
              OrderId: orderId.toString(),
              Lang: this.lang
            };

            //setting messages as read
            let messReadSub = this.messagesService.setMessagesAsRead(params)
              .subscribe(result => { })

            this.subManager.add(messReadSub);

            this.showModal();

            //reseting of value of OrderNoteList
            order.OrderNoteList = []
          }
        }
        else if (columnName == "Reorder") {

          let orderId = this.rows[indexRow].OrderId;
          this.getRiOrdersList(orderId);
        }
      }
      messagesDetails(orderId) {
        $("#messagesModal").modal("hide");
        let id = orderId;
        let orderDetailsPage = this.routesService.getRoutePath('AREA CLIENTI - ORDINE_PAGE_FROM')[0];

        orderDetailsPage = orderDetailsPage.replace(':id', id.toString()).replace(':pagefrom', "section_comunicazioni");

        this.router.navigate([orderDetailsPage]);
        return true;
      }

      showModal() {
        $("#messagesModal").modal("show");
      }

      hideModal() {
        $('#basic').modal('hide');

        this.bodyMod = [];
      }



      getOrdersList(userId: string, dateFrom: string, dateTo: string, orderNumber: string, orderStatus: string) {
        this.load = true;
        let orderListSub = this.clientAreaService.getClientAreaOrdersList1(userId, dateFrom, dateTo, orderNumber, orderStatus)
          .subscribe(result => {

            this.rows = result.ClientAreaOrderList;

            this.load = false;

            this.resetTable(this.rows);
          })

        this.subManager.add(orderListSub);
      }

      //destroying of current context of table and creating a new one with new data
      resetTable(tableData) {
        $('#datatable').DataTable().destroy();
        let currentLang = this.currentLang;
        setTimeout(function () {
          $('#datatable').DataTable
            (
              {
                data: this.rows,
                searching: false,
                ordering: false,
                sDom: 'Rlfrtlip',
                oLanguage: currentLang
              }
            );
        }, 0);

        setTimeout(function () { $('.dataTables_length').not(':eq(1)').hide() }, 0);
      }

      resetFilter() {
        this.from = "";
        this.to = "";
        $('#fromDate').val("");
        $('#toDate').val("");
        this.status = "0";
        this.orderNumber = "";
        if (this.isSettedFilter == true) {
          this.isSettedFilter = false;
          //this.rows = ClientAreaOrderListTemplate.ClientAreaOrderList;
          let userId = this.authService.GetUserId();
          let showAll: string = "-1"
          this.getOrdersList(userId, showAll, showAll, showAll, showAll);
        }
      }

      filterOrdersList() {
        this.isSettedFilter = true;
        let orderStatus: string;
        let numberOfOrder: string;

        let userId = this.authService.GetUserId();
        this.from = $('#fromDate').val();
        this.to = $('#toDate').val();

        let dateFrom = this.changeDate(this.from);
        let dateTo = this.changeDate(this.to);

        if (dateFrom == "") {
          dateFrom = "-1";
        }

        if (dateTo == "") {
          dateTo = "-1";
        }

        if (dateFrom == "Invalid date" || null) {
          dateFrom = "-1";
        }

        if (dateTo == "Invalid date" || null) {
          dateTo = "-1";
        }

        if (this.status == "0") {
          orderStatus = "-1";
        }

        else {
          orderStatus = this.status
        }

        if (this.orderNumber == "") {
          numberOfOrder = "-1";
        }

        else {
          numberOfOrder = this.orderNumber
        };

        this.getOrdersList(userId, dateFrom, dateTo, numberOfOrder, orderStatus);
      }

      changeDate(stringDate) {
        let date = stringDate.replace(/\//g, "-");
        return date;
      }

      getClassforMenuClientArea() {
        let result;
        if (this.isActiveInvoicesModule && this.isCatalogPrivateActive) {
          result = "col-md-3 col-sm-3"
        }
        else if ((!this.isActiveInvoicesModule && this.isCatalogPrivateActive) || (this.isActiveInvoicesModule && !this.isCatalogPrivateActive)) {
          result = "col-md-3 col-sm-3"
        }
        else if (!this.isActiveInvoicesModule && !this.isCatalogPrivateActive) {
          result = "col-md-4 col-sm-4"
        }
        return result
      }

      showModalRiordina(orderId) {

        this.getRiOrdersList(orderId)


      }
      hideModalRiordina() {
        $("#ReorderModal").modal("hide");
      }

      resetTableReorder() {
        let currentLang = this.currentLang;
        $("#ReorderModal").modal("show");
        setTimeout(function () { 
          $('.popovers').popover(); 
        }, 150);
      }

      riordina() {
        //let valueReorderList: Array<{ QuantityID: number, ProductID: number, tipoCalcolo: string, DateID: number, tipoProdotto: string, CustomerID: string, CartID: string, Language: string, Currency: string }> = [];
        let valueReorderList: Array<{ CartID: string, CustomerID: string, Language: string, ProductID: number, LavID: string, DateID: number, Currency: string, tipoProdotto: string, tipoCalcolo: string }> = [];
        //this.cartService.setCartId(cart.CartId)
        var selectedCount = $('input[name="selectAllItems"]:checked').length;
        var selectedCountCheck = 0;
        var stringInputCheck = "";
        if (selectedCount > 0) {
          var CustomerID = this.cartService.getCustomerId();
          var CartID = this.cartService.getCartId();
          var Language = this.cartService.getLang();
          var Currency = this.currency.getCurrency();
          $('.disableInputReorder').attr('disabled', true);
          this.loadReorder = true;

          $('input[name="selectAllItems"]:checked').each(function (index, element) {
            var id = parseInt(element.id.replace("check_", ""));
            stringInputCheck = 'input[name="priceresult_' + id + '"]:checked'
            $(stringInputCheck).each(function (index, elementcheck) {
              var ProductID = parseInt($(elementcheck).attr("prodId"));
              var QuantityID = parseInt($(elementcheck).attr("rowidcalcolo"));
              var LavID = $(elementcheck).attr("rowidcalcolo");
              var tipoCalcolo = $(elementcheck).attr("tipocalcolo");
              var DateID = parseInt($(elementcheck).attr("idDay"));
              var tipoProdotto = $(elementcheck).attr("tipoprodotto");
              valueReorderList.push({ CartID, CustomerID, Language, ProductID, LavID, DateID, Currency, tipoProdotto, tipoCalcolo });
            });
          });
          var lenghtReorderList = valueReorderList.length;
          if (lenghtReorderList > 0) {
            let riorderListSub = this.cartService.addProductRiorderToCart(valueReorderList)
              .subscribe(result => {
                this.cartService.updateCart(result);
                this.hideModalRiordina();
                $('.disableInputReorder').removeAttr('disabled');
                this.bootboxService.i18nAlert("productAddedToCart");
                this.loadReorder = false;
              },
                err => {
                  $('.disableInputReorder').removeAttr('disabled');
                  this.bootboxService.i18nAlert("errorMex");
                  this.loadReorder = false;
                }
              );

            this.subManager.add(riorderListSub);
          }
          else {
            this.bootboxService.alertForRiorderFail("reorder_seleziona_almeno_una_qta");
            $('.disableInputReorder').removeAttr('disabled');
            this.loadReorder = false;
          }
        }
        else {
          this.bootboxService.alertForRiorderFail("reorder_seleziona_almeno_una_riga");
        }
      }

      getRiOrdersList(orderId) {
        this.loadReorder = true;
        let riorderListSub = this.clientAreaService.getClientAreaRiorderList(orderId)
          .subscribe(result => {
            this.rowsRiorder = result;
            this.loadReorder = false;
            //initialization of datatable
            this.resetTableReorder();
          })

        this.subManager.add(riorderListSub);
      }

      getLabel(label) {
        let message;

        this.translateService.get(label, this.translateService).subscribe((res: string) => {
          message = res;
        });
        return message;
      }

      calculatePrice(idRow, index) {
        var qta = $('#riga_' + idRow).val();
        var riga = this.rowsRiorder[index];
        if (riga != null && qta > 0) {
          this.loadReorder = true;
          $('.disableInputReorder').attr('disabled', true);
          var newQta = "&NumCopie=" + qta + "&"
          var newQtaOther = "&str_qt=" + qta + "&"
          var OldQta = "&NumCopie=" + riga.Quantity + "&"
          var OldQtaOther = "&str_qt=" + riga.Quantity + "&"
          var queryLavorazione2 = riga.LavorazioneQuery.replace(OldQta, newQta)
          var queryLavorazione3 = queryLavorazione2.replace(OldQtaOther, newQtaOther)
          var substring = queryLavorazione3.indexOf("&Datetime");
          var queryLavorazione = queryLavorazione3.slice(0, substring)
          queryLavorazione += "&orderid=" + riga.OrderId;
          queryLavorazione += "&orderlavid=" + riga.IdRow;
          if (queryLavorazione.indexOf("sezione=") != -1) {
            let riorderListSub = this.clientAreaService.CalculatePriceRiorder(queryLavorazione, riga.ProdId)
              .subscribe(result => {
                //console.log(result)
                switch (result.resultType) {
                  case "calcolato_wizard_scontistica":
                    this.showPriceCalcolatoScontistica(idRow, result.TablePriceList, result.resultType, riga.ProdId, result.RowId, riga.TipoProdotto)
                    break;
                  case "calcolato_wizard":
                  case "calcolato_wizard_altro_prodotto":
                    this.showPriceCalcolato(idRow, result, result.resultType, riga.ProdId, result.RowId)
                    break;
                }
                //this.rowsRiorder = result;
                this.loadReorder = false;
              })
            this.subManager.add(riorderListSub);
            let getRiorderCart = this.cartService.getRiorderCart()
              .subscribe(cart => {
                var cartIdOld = this.cartService.getCartId();
                if (cartIdOld == "0") {
                  this.cartService.setCartId(cart.CartID);
                }
              })
            this.subManager.add(getRiorderCart);
          }
        }
        else {
          $('#Prezzo_' + idRow).html("");
        }
      }

      showPriceCalcolatoScontistica(idRow, result, type, prodId, rowIdCalcolo, rowTipoProdotto) {
        $('#Prezzo_' + idRow).html("");
        var html = "";
        let resultFiltered = result.filter(x => x.Price != -1);
        var lenghtRes = resultFiltered.length - 1;
        resultFiltered.forEach((price, index) => {
          if (price.Price != -1) {
            html += "<div>";
            if (lenghtRes == index) {
              html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "_" + price.QuantityId + "\" value=\"0\"  tipoprodotto=\"" + rowTipoProdotto + "\" tipocalcolo=\"" + type + "\"  prodId=\"" + prodId + "\" rowidcalcolo=\"" + rowIdCalcolo + "\"  idDay=\"" + price.QuantityId + "\" required checked>";
            }
            else {
              html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "_" + price.QuantityId + "\" value=\"0\"  tipoprodotto=\"" + rowTipoProdotto + "\" tipocalcolo=\"" + type + "\"  rowidcalcolo=\"" + rowIdCalcolo + "\" prodId=\"" + prodId + "\" idDay=\"" + price.QuantityId + "\" required>";
            }
            html += "<label class=\"riordinaLabel\" for=\"" + rowIdCalcolo + "_" + price.QuantityId + "\">" + price.DayName + " " + price.DayNumber + " - " + price.Currency + " " + price.StrPrice + "</label>";
            html += "</div>";
          }
        });
        $('#Prezzo_' + idRow).html(html);
        $('.disableInputReorder').removeAttr('disabled');
      }

      showPriceCalcolato(idRow, price, type, prodId, rowIdCalcolo) {
        $('#Prezzo_' + idRow).html("");
        var html = "";
        html += "<div>";
        html += "<input class=\"riordinaRadio\" type=\"radio\" name=\"priceresult_" + idRow + "\" id=\"" + rowIdCalcolo + "\" value=\"0\"  tipocalcolo=\"" + type + "\"  rowidcalcolo=\"" + rowIdCalcolo + "\" prodId=\"" + prodId + "\" checked required>";
        html += "<label class=\"riordinaLabel\" for=\"" + rowIdCalcolo + "\">" + price.Currency + " " + price.Imponibile + "</label>";
        html += "</div>";

        $('#Prezzo_' + idRow).html(html);
        $('.disableInputReorder').removeAttr('disabled');
      }


      ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
      }
    }
    return ChildComponent;
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/document/sys/client-area-order-list.component.ts